import React from 'react';
import { Accordion, Card } from 'react-bootstrap';

const Feature = ({feature, highlight=false, onHover}) => {
  const bgcolor = (probability) =>{
    if (probability < 0.1) {
      return "rgba(50, 136, 189, 0.3)"
    } else if (probability < 0.2) {
      return "rgba(102, 194, 165, 0.3)"
    } else if (probability < 0.3) {
      return "rgba(171, 221, 164, 0.3)"
    } else if (probability < 0.4) {
      return "rgba(230, 245, 155, 0.3)"
    } else if (probability < 0.5) {
      return "rgba(255, 255, 191, 0.3)"
    } else if (probability < 0.6) {
      return "rgba(254, 224, 139, 0.3)"
    } else if (probability < 0.7) {
      return "rgba(253, 174, 97, 0.3)"
    } else if (probability < 0.8) {
      return "rgba(244, 109, 67, 0.3)"
    } else if (probability >= 0.8) {
      return "rgba(213, 62, 79, 0.3)"
    }
  }
  const style = {
    fontWeight: highlight ? "bold" : "inherit",
    backgroundColor: bgcolor(feature.properties.probability),
    cursor: 'pointer'
  }

  return (
    <React.Fragment>
      <Accordion.Toggle
        as={Card.Header}
        onMouseOver={()=>(onHover(feature))}
        style={style}
        eventKey={feature.properties.id}
        >
        {feature.properties.name}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={feature.properties.id}>
        <Card.Body>
          { Object.entries(feature.properties).sort((a,b)=>(b.probability - a.probability)).map(([key, val])=>{
            return (
              <React.Fragment key={key}>
                <strong>{key}</strong>: {val}<br/>
              </React.Fragment>
            )
          }) }
        </Card.Body>
      </Accordion.Collapse>
    </React.Fragment>
  )
}
const FeaturesList = ({features, highlightIds, onHover}) => {
  const isHighlighted = (id) => (highlightIds.includes(id))

  return (
    <div style={{width: "100%", height: "100%", overflow: "auto", position: "absolute"}}>
      <Accordion>
        {
          features && features.features && features.features.map((feature) => {
            return (
              <Feature
                feature={feature}
                key={feature.properties.id}
                onHover={onHover}
                highlight={isHighlighted(feature.properties.id)}
                />
              )
          })
        }
      </Accordion>
    </div>
  )
}

export default FeaturesList